import { isMobile } from "components/utility/page-responsive/PageResponsive";
import { onElementReady } from "utils/onElementReady";

const animatePremiums = (entry) => {
	const numberOfCharts = 3;
	const splitContainer = entry.target;
	if (splitContainer) {
		// only animate if page starts off at sizes > 768, otherwise start at static
		if (!splitContainer.querySelector(".ddiff-premium-resize-static")) {
			// if a user refreshes the page in the middle of the split content,
			// the animation will not trigger because react has not added the html to the dom yet
			// wait for the content to appear before triggering any animations
			onElementReady(".ddiff-two-column-one-to-three-quarters").then(() => {
				const premiumsTitleAndToggle = splitContainer.querySelector(".ddiff-premiums-info-title");
				if (premiumsTitleAndToggle)
					premiumsTitleAndToggle.classList.add("ddiff-premiums-info-title-animate");

				const premiumsCharts = splitContainer.querySelectorAll(".ddiff-premium");
				if (premiumsCharts.length)
					[...premiumsCharts].forEach((chart, i) => {
						if (i < numberOfCharts) chart.classList.add("ddiff-premium-animate");
					});

				const toggle = splitContainer.querySelector(".ddiff-premiums-switch-container");
				if (toggle) toggle.classList.add("ddiff-premiums-switch-container-animate");

				// animations for charts are similar
				// this function creates an array of all animation classes per chart that need to be added
				const animationSequence = [];
				for (let i = 0; i < numberOfCharts; i++) {
					animationSequence.push(
						{
							parent: `.ddiff-premium-chart-${i}`,
							elementToAnimate: ".ddiff-equity-copy",
							classToAdd: "ddiff-equity-copy-animate"
						},
						{
							parent: `.ddiff-premium-chart-${i}`,
							elementToAnimate: ".ddiff-equity-svg",
							classToAdd: "ddiff-equity-svg-animate"
						}
					);
				}

				// find the parent chart
				// find the element that needs to animate
				// add the animation class
				animationSequence.forEach((sequence) => {
					const parent = splitContainer.querySelector(sequence.parent);
					if (parent) {
						const div = parent.querySelectorAll(sequence.elementToAnimate);
						if (div.length) {
							if (div.length > 1) {
								div.forEach((d) => {
									d.classList.add(sequence.classToAdd);
								});
							} else {
								div[0].classList.add(sequence.classToAdd);
							}
						}
					}
				});
			});
		}
	}
};

const setPremiumsToStaticOnResize = () => {
	// nav bar on ios causes resize event to trigger on scroll,
	// this check prevents functions from running if there was NOT a size change
	if (window.innerWidth !== isMobile && window.innerWidth !== window._WINDOW_WIDTH_IOS) {
		window._WINDOW_WIDTH_IOS = window.innerWidth;
		const premiumsContainer = document.querySelector(".ddiff-animated-exhibit-premiums");
		if (premiumsContainer) {
			const toggleSwitch = premiumsContainer.querySelector(".ddiff-premiums-switch-container");
			if (toggleSwitch) {
				toggleSwitch.classList.remove("ddiff-premiums-switch-container-animate");
				toggleSwitch.classList.add("ddiff-premium-resize-static");
			}

			const equities = premiumsContainer.querySelectorAll(".ddiff-equity-copy");
			if (equities.length) {
				const equitySvgs = premiumsContainer.querySelectorAll(".ddiff-equity-svg");
				// if screen starts as xs and resized to xs|sm|lg
				// when premiums starts at xs, there have been no 'animate' classes added
				if (equities[0].classList.length === 1) {
					const premiumsTitleAndToggle = premiumsContainer.querySelector(
						".ddiff-premiums-info-title"
					);
					if (premiumsTitleAndToggle)
						premiumsTitleAndToggle.classList.add("ddiff-premium-resize-static");
					const charts = premiumsContainer.querySelectorAll(".ddiff-premium");
					if (charts.length) {
						charts.forEach((chart, i) => {
							if (i < 3) chart.classList.add("ddiff-premium-resize-static");
						});
					}
					equities.forEach((equity) => {
						equity.classList.add("ddiff-premium-resize-static");
					});

					if (equitySvgs.length) {
						equitySvgs.forEach((equitySvg) =>
							equitySvg.classList.add("ddiff-premium-resize-static")
						);
					}
				}

				// if equity has animated on and user resizes to xs and back to sm|md|lg
				// set equity tab to static
				const fixedHasntAnimated = premiumsContainer.querySelectorAll(
					".ddiff-fixed-copy.ddiff-premiums-hide"
				);
				if (fixedHasntAnimated.length) {
					[...equities].forEach((equity) => {
						equity.classList.remove("ddiff-equity-copy-animate");
						equity.classList.add("ddiff-premium-resize-static");
					});
				}
				// in sm|md|lg if fixed tab is visible and user resizes to xs and back to sm|md|lg
				// remove equity fade-out animation classes
				// set fixed tab to static
				else {
					[...equities].forEach((equity) => {
						equity.classList.remove("ddiff-premium-copy-hide");
					});

					if (equitySvgs.length) {
						[...equitySvgs].forEach((equitySvg) => {
							equitySvg.classList.remove("ddiff-premium-svg-hide");
						});
					}

					const fixed = premiumsContainer.querySelectorAll(".ddiff-fixed-copy-animate");
					if (fixed.length) {
						[...fixed].forEach((equity) => {
							equity.classList.remove("ddiff-fixed-copy-animate");
							equity.classList.add("ddiff-premium-resize-static");
						});
					}
				}
			}
		}
	}
};

window.addEventListener("resize", () => setPremiumsToStaticOnResize(), { once: true });

export { animatePremiums };
